export const RouteConstants = {
    LOGIN: "/login",
    AUTH_ERROR: "/auth-error",
    UNAUTHORIZED: "/unauthorized",
    AUTH_CALLBACK: "/callback",
    LOGOUT: "/logout",
    OTC_CALLBACK: "/otcCallback",
    ERROR: "/error",

    HOME: "/home",
    TICKET_QUEUE: '/queue/:associateId?',
    MY_TICKET_QUEUE: '/queue',
    TICKET: '/tickets/:id?',
    UNASSIGNED_VDO: '/unassigned-vdo',
    CLIENTS_SEARCH: '/clients/search',
    CLIENT_INFO: '/clients/:id?',
    RETURN_INFO: '/returns/:id?/clients/:clientId?/year/:taxYear?',
    PRESALE_INFO: '/presales/:id?/year/:taxYear?',
    RETURN_STATUS: '/filedreturn/:id?/year/:taxYear?',
    OTE_INFO: '/otes/:id?',
    PARTY_INFO: '/party/:id?',
    DISTRICTS: '/district-offices',
    OFFICES: '/offices/:officeId?',
    MY_ASSOCIATES_BASE: '/associates',
    MY_ASSOCIATES: '/associates/:employeeId?',
    REASSIGN: '/reassign',
    //temporary routes
    PASS_USER_NAME: "/pass-user-name",
    OTC_LOAD: "/otc",
    RETURN_STATUS_BY_VMID: '/filedreturns/:vmId?/year/:taxYear?'
};
